import { render, staticRenderFns } from "./Snackbar.vue?vue&type=template&id=0fd13b12&scoped=true"
var script = {}
import style0 from "./Snackbar.vue?vue&type=style&index=0&id=0fd13b12&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0fd13b12",
  null
  
)

export default component.exports